// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"_7-z"};